import { Toast, ToastVariant } from "@/constants/toast"
import { toast } from "@/redux/reducers/toast"

export const showWorkflowErrorNotification = (message: string) => {
  return toast({
    title: Toast.ERROR,
    variant: ToastVariant.ERROR,
    description: message
  })
}
